import { Typography } from '@mui/material';
import React from 'react';
const SidebarMemberProfile = () => {
    return React.createElement(Typography, null, "Member Profile");
};
export default SidebarMemberProfile;
